"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebWallet = void 0;
const anchor_1 = require("@project-serum/anchor");
class WebWallet {
    constructor(publicKey, signTransaction, signAllTransactions, sendTransaction) {
        this._publicKey = publicKey;
        this._signTransaction = signTransaction;
        this._signAllTransactions = signAllTransactions;
        this.sendTransaction = sendTransaction;
        this.payer = new anchor_1.web3.Keypair();
    }
    static fakeWallet() {
        return new WebWallet(anchor_1.web3.PublicKey.default, (transaction = new anchor_1.web3.Transaction()) => { return Promise.resolve(transaction); }, (transaction = [new anchor_1.web3.Transaction()]) => { return Promise.resolve(transaction); }, () => { });
    }
    async signTransaction(tx) {
        return this._signTransaction(tx);
    }
    async signAllTransactions(txs) {
        return this._signAllTransactions(txs);
    }
    get publicKey() {
        return this._publicKey;
    }
}
exports.WebWallet = WebWallet;
//# sourceMappingURL=web.js.map